const LargeXIcon = () => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_15_633)">
        <rect x="2" y="1.5" width="52" height="52" rx="8" fill="white" />
        <rect x="2.5" y="2" width="51" height="51" rx="7.5" stroke="#D9D9D9" />
        <path
          d="M34.0672 32.6828C34.1253 32.7409 34.1713 32.8098 34.2028 32.8857C34.2342 32.9616 34.2504 33.0429 34.2504 33.125C34.2504 33.2071 34.2342 33.2884 34.2028 33.3643C34.1713 33.4402 34.1253 33.5091 34.0672 33.5672C34.0091 33.6253 33.9402 33.6713 33.8643 33.7027C33.7885 33.7342 33.7071 33.7503 33.625 33.7503C33.5429 33.7503 33.4616 33.7342 33.3857 33.7027C33.3098 33.6713 33.2409 33.6253 33.1828 33.5672L28 28.3836L22.8172 33.5672C22.6999 33.6845 22.5409 33.7503 22.375 33.7503C22.2092 33.7503 22.0501 33.6845 21.9328 33.5672C21.8155 33.4499 21.7497 33.2909 21.7497 33.125C21.7497 32.9591 21.8155 32.8001 21.9328 32.6828L27.1164 27.5L21.9328 22.3172C21.8155 22.1999 21.7497 22.0409 21.7497 21.875C21.7497 21.7091 21.8155 21.5501 21.9328 21.4328C22.0501 21.3155 22.2092 21.2497 22.375 21.2497C22.5409 21.2497 22.6999 21.3155 22.8172 21.4328L28 26.6164L33.1828 21.4328C33.3001 21.3155 33.4592 21.2497 33.625 21.2497C33.7909 21.2497 33.9499 21.3155 34.0672 21.4328C34.1845 21.5501 34.2504 21.7091 34.2504 21.875C34.2504 22.0409 34.1845 22.1999 34.0672 22.3172L28.8836 27.5L34.0672 32.6828Z"
          fill="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15_633"
          x="0"
          y="0.5"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_633"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_633"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LargeXIcon;
